import React, { FC } from 'react'
import { Button as AntButton } from 'antd'
import { ButtonProps } from 'antd/es/button/button'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import styles from './Button.module.scss'

export type ButtonType = 'primary' | 'secondary' | 'icon' | 'secondary-icon' | 'transparent'

interface CustomButtonProps extends Omit<ButtonProps, 'type'> {
  buttonType?: ButtonType
  icon?: React.ReactNode
  to?: string
  activeClassName?: string
}

const CustomButton: FC<CustomButtonProps> = ({ 
  buttonType = 'primary', 
  icon, 
  children, 
  className, 
  to, 
  activeClassName,
  ...props 
}) => {
  const getButtonProps = () => {
    switch (buttonType) {
      case 'primary':
        return {
          type: 'primary' as const,
          className: classNames(className, styles.button, styles.primary),
        }
      case 'secondary':
        return {
          type: 'default' as const,
          className: classNames(className, styles.button, styles.secondary),
        }
      case 'icon':
        return {
          type: 'primary' as const,
          icon,
          className: classNames(className, styles.button, styles.iconButton),
        }
      case 'secondary-icon':
        return {
          type: 'default' as const,
          icon,
          className: classNames(className, styles.button, styles.secondaryIconButton),
        }
      case 'transparent':
        return {
          type: 'text' as const,
          icon,
          className: classNames(className, styles.button, styles.transparent),
        }
      default:
        return {
          type: 'primary' as const,
          className: classNames(className, styles.button),
        }
    }
  }

  const buttonProps = getButtonProps()

  if (to) {
    return (
      <NavLink to={to} className={(isActive: boolean) => isActive ? activeClassName || '' : ''}>
        <AntButton {...buttonProps} {...props}>
          {children}
        </AntButton>
      </NavLink>
    )
  }

  return (
    <AntButton {...buttonProps} {...props}>
      {children}
    </AntButton>
  )
}

export default CustomButton
